/** Shared layout tokens for fixed-size event cards and group tiles. */

export const IMAGE_ASPECT_RATIO = 16 / 9;

export const IMAGE_ASPECT_RATIO_CSS = '16 / 9';

/** Base sx for fixed 16:9 image panels — used on event cards and event group tiles. */
export const fixedAspectRatioImageSx = {
    aspectRatio: IMAGE_ASPECT_RATIO_CSS,
    flexShrink: 0,
    alignSelf: 'flex-start',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
} as const;

/** Fixed event card width — sized for the smallest common phone viewport (iPhone SE). */
export const EVENT_CARD_WIDTH = 320;

/** Narrow viewport breakpoint (px) — matches EVENT_CARD_WIDTH; use for max-width media queries. */
export const NARROW_VIEWPORT_MAX = EVENT_CARD_WIDTH;

/** MUI sx / CSS media query for viewports at or below NARROW_VIEWPORT_MAX. */
export const narrowViewportMediaQuery = `@media (max-width: ${NARROW_VIEWPORT_MAX}px)` as const;

/** Fixed image panel width for event group tiles on desktop (side-by-side layout). */
export const EVENT_GROUP_IMAGE_WIDTH = 480;

export const CARD_GRID_GAP = 20;

/** Fixed width of the desktop event-group sidebar (≥1440px viewport). */
export const EVENTS_SIDEBAR_WIDTH = 220;

/** Max content width for the events listing page. */
export const EVENTS_PAGE_MAX_WIDTH = 1400;
